<template>
  <paginated-table
    id="admin-gbfs-datasets-table"
    ref="table"
    endpoint="gbfs_datasets"
    :columns="columns"
    :label="$t('views.admin.gbfs_datasets.title') | capitalize"
    :show-generate-csv="false"
    show-action-column
    key-column="name"
    initial-sort-by="name"
    row-link
  >
    <template #head-buttons>
      <icon-button role="add" to="/admin/gbfs_datasets/new">
        {{ $t("views.admin.gbfs_datasets.actions.new") | capitalize }}
      </icon-button>
    </template>
    <template #cell(actions)="{ item }">
      <admin-list-actions
        slug="communities"
        :item-name="item.name"
        :item="item"
        :destroy-action="destroyStream"
        :show-restore="false"
        :archive-label="$t('forms.delete')"
        @change="$refs.table.refresh"
      />
    </template>
  </paginated-table>
</template>

<script>
import AdminListActions from "@/components/Admin/ListActions.vue";
import IconButton from "@/components/shared/IconButton.vue";
import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column } from "@/components/shared/PaginatedTableColumns";
import { capitalize } from "@/helpers/filters";
import { del } from "@/requests/server";

export default {
  name: "AdminGbfsDatasets",
  components: {
    IconButton,
    AdminListActions,
    PaginatedTable,
  },
  data() {
    return {
      columns: [
        new Column("name", this.$t("views.admin.gbfs_datasets.columns.name"), "text", {}),
        new Column(
          "notes",
          capitalize(this.$t("views.admin.gbfs_datasets.columns.notes")),
          "text",
          {
            formatter: this.truncateNotes,
          }
        ),
        Column.withoutFilter(
          "link",
          capitalize(this.$t("views.admin.gbfs_datasets.columns.link")),
          "text",
          {
            urlFct: (item) => item.link + "/gbfs",
            sortable: false,
            formatter: () => capitalize(this.$t("views.admin.gbfs_datasets.link_text")),
          }
        ),
        Column.withRelationCount(
          "communities_count",
          capitalize(this.$t("views.admin.gbfs_datasets.columns.communities_count"))
        ),
      ],
    };
  },
  methods: {
    async destroyStream(item) {
      await del(`/gbfs_datasets/${item.name}`, {
        notifications: {
          action: this.$t("views.admin.gbfs_datasets.notifications.delete.action"),
          resourceName: this.$t("views.admin.gbfs_datasets.notifications.delete.resource"),
          onSuccess: true,
        },
      });
    },
    truncateNotes(notes) {
      if (!notes) {
        return "";
      }

      const firstLineBreak = notes.indexOf("\n");
      const maxLength = Math.min(firstLineBreak > 0 ? firstLineBreak : notes.length, 77);

      return notes.substring(0, maxLength) + (maxLength < notes.length ? "..." : "");
    },
  },
};
</script>

<style lang="scss"></style>
